const bigData = () => import('Views/bigData/big-data');

export default[
  { path: '/big-data-headFull', component: bigData },
];



// WEBPACK FOOTER //
// ./src/router/bigData.js